import { render, staticRenderFns } from "./new-transit.vue?vue&type=template&id=3eccc7a8&scoped=true&"
import script from "./new-transit.vue?vue&type=script&lang=js&"
export * from "./new-transit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3eccc7a8",
  null
  
)

export default component.exports